import { Box, Typography, TextField, Button, Grid, IconButton, InputAdornment, CircularProgress } from '@mui/material';
import COLORS from '../../../../constants/colors';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Google, Facebook } from '@mui/icons-material';
import Header from './Header';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate for redirection
import SnackbarAlert from '../Reusbale/SnackbarAlert'; // Snackbar for messages
import baseURL from '../config'; // API base URL
import GoogleLoginButton from '../Login/GoogleLogin';
import Footer from '../../../Reusable/Footer';
import { toast } from 'react-toastify';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  if (!formData.email || !formData.password) {
    toast.error('Email and password are required!', {
      className: 'custom-toast-font custom-toast-body-size',
    });
    setLoading(false);
    return;
  }

  try {
    const response = await fetch(`${baseURL}/auth/user/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      // 👇 check for "email not verified" error from backend
      if (data.message && data.message.toLowerCase().includes("email is not verified")) {
        toast.error("Your email is not verified. Redirecting...", {
          className: 'custom-toast-font custom-toast-body-size',
        });

        // Redirect to verify-email page and pass email in query string
        setTimeout(() => navigate(`/user/resend-verify-email-link?email=${encodeURIComponent(formData.email)}`), 1500);
        return;
      }

      throw new Error(data.message || 'Invalid credentials');
    }

    toast.success('Login successful!', {
      className: 'custom-toast-font custom-toast-body-size',
    });

    if (data.user.organisation_id) {
      setTimeout(() => navigate('/org/dashboard'), 1000);
    } else {
      setTimeout(() => navigate('/user/dashboard'), 1000);
    }

  } catch (error) {
    toast.error(error.message);
  } finally {
    setLoading(false);
  }
};


    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };







    return (
        <Box>

            <Header />

            <Box sx={{ py: 3, px: 2, maxWidth: 400, margin: '0 auto', textAlign: 'center' }}>
                {/* Header */}
                <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={2}>
                    Welcome Back!
                </Typography>
                <Typography variant="body1" color={COLORS.text} mb={4}>
                    Login to your account and continue exploring.
                </Typography>

                {/* Social Login Buttons */}
                <Grid container spacing={2} mb={3}>
                    <Grid item xs={12} sm={12}>
                       <GoogleLoginButton /> 
                    </Grid>
                    
                </Grid>

                {/* Login Form */}
                <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                    {/* Email Field */}
                    <TextField
                        name="email"
                        label="Email Address"
                        variant="outlined"
                        fullWidth
                        value={formData.email}
                        onChange={handleChange}
                        sx={{
                            mb: 2,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                fontSize: '1rem',
                                '& input': { padding: '14px' }, // Increased height
                            },
                        }}
                        InputLabelProps={{ style: { color: COLORS.primary, fontSize: '1rem' } }} // Increased font size
                        InputProps={{
                            style: { color: COLORS.text },
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faUser} style={{ color: COLORS.primary }} />
                                </InputAdornment>
                            ),
                        }}
                    />

                    {/* Password Field */}
                    <TextField
                        name="password"
                        label="Password"
                        variant="outlined"
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        value={formData.password}
                        onChange={handleChange}
                        sx={{
                            mb: 2,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                fontSize: '1rem',
                                '& input': { padding: '14px' }, // Increased height
                            },
                        }}
                        InputLabelProps={{ style: { color: COLORS.primary, fontSize: '1rem' } }} // Increased font size
                        InputProps={{
                            style: { color: COLORS.text },
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faLock} style={{ color: COLORS.primary }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} style={{ fontSize: '16px'}} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    {/* Login Button */}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            backgroundColor: COLORS.primary,
                            color: COLORS.white,
                            borderRadius: '10px',
                            py: 1.2, // Increased padding
                            fontSize: '1rem',
                            textTransform: 'none',
                            boxShadow:0,
                            '&:hover': { backgroundColor: COLORS.secondary },
                        }}
                    >
                        {loading ? <CircularProgress size={22} color="inherit" /> : 'Login'}
                    </Button>
                </Box>

                {/* Forgot Password & Signup */}
                <Box mt={2} sx={{textAlign:'right'}}>
                    

                    <Typography variant="body2" color={COLORS.text} mt={1}>
                        Forgot password?{' '}
                        <Link to="/user/forgot-password" style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: 'bold' }}>
                            Reset Password
                        </Link>
                    </Typography>

                    <Typography variant="body2" color={COLORS.text} mt={1}>
                        Don't have an account?{' '}
                        <Link to="/user/register" style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: 'bold' }}>
                            Sign Up
                        </Link>
                    </Typography>

                    <Typography variant="body2" color={COLORS.text} mt={2}>
                        <Link to="/" style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: 'bold' }}>
                            &larr; Back to Home
                        </Link>
                    </Typography>
                </Box>
            </Box>

            {/* Snackbar for Messages */}
            <SnackbarAlert open={snackbar.open} message={snackbar.message} severity={snackbar.severity} handleClose={handleCloseSnackbar} />

            <Footer />
        </Box>
    );
};

export default Login;
